module.exports = __webpack_public_path__ + "img/tp-logo.199f4112.png";